module.exports = __webpack_public_path__ + "img/TV_clean_box11.9edfa1b6.jpg";